module.exports = __webpack_public_path__ + "img/fi-ss-document.68182c5d.svg";